import { pluginFactory } from '@/plugins/plugin'
import { HelloWorldPlugin } from './HelloWorld'
import { PLKMapPlugin } from './PLKMap'

export const ExamplePlugins = pluginFactory({
  plugins: {
    HelloWorldPlugin,
    PLKMapPlugin
  }
})

export { HelloWorld } from './HelloWorld'
export { PLKMap } from './PLKMap'
